import { User } from '@img-arena/consoles-api-streaming'
import { streamingRestApi } from '@/service/streamingApi'

import { createBaseTableStore } from '../table'
import type { FetchApiArgs, FetchApiResponse } from '../table/table.types'

export type DGE_UserSortAttribute =
  | 'fullName'
  | 'email'
  | 'mainNumber'
  | 'company'
  | 'role'
  | 'operator'
  | 'lastLogin'
export type DGE_UserFilterParamName = 'filter'

const fetchDGEUsersApiCallback = async (
  args: FetchApiArgs<unknown, DGE_UserSortAttribute, DGE_UserFilterParamName>
): Promise<FetchApiResponse<User>> => {
  const { page, pageSize, sort, filters, signal } = args

  const queryFromFilters = filters.filter?.[0]?.value?.toString() || undefined

  const {
    data: { content, ...restResponse }
  } = await streamingRestApi.endpoints.users.getAll(
    {
      page,
      pageSize,
      sortKey: sort?.attribute,
      sortDirection: sort?.order,
      query: queryFromFilters
    },
    signal
  )

  return {
    content,
    totalElements: restResponse.totalElements,
    number: restResponse.number,
    size: restResponse.size
  }
}

export const useUsersStoreDGE = createBaseTableStore({
  storeName: 'DGE Users',
  fetchApi: fetchDGEUsersApiCallback,
  features: {
    pagination: true,
    sorting: true,
    filtering: true
  }
})
